<template>
	<gofix-card :title="title" :classHeader="title ? 'pb-10 pl-23' : ''" class="mb-0" fullContent>
        <gofix-default-table
            :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @new-item="newItem"
            @row-click="rowClick"
            @delete-items="deleteItems"
            ref="gofixTable">
        </gofix-default-table>
        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create" 
            title="Add Part Location"  
            hide-footer 
            :centered="true" 
            v-model="modals.create.open">
            <div class="" v-bind:class="{'run-loading':modals.create.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-input
                                label="Name"
                                v-model="modals.create.data.name"
                                required />
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="APPLY" @click="savePartLocation" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create" 
            title="Edit Part Location"  
            hide-footer 
            :centered="true" 
            v-model="modals.update.open">
            <div class="" v-bind:class="{'run-loading':modals.update.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-input
                                label="Name"
                                v-model="modals.update.data.name"
                                required />
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="APPLY" @click="updatePartLocation" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </gofix-card>
    
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import {mapGetters} from "vuex";
    export default {
        name: 'parts-location',
        data() {
            let filter = JSON.parse(JSON.stringify(filters['parts_location']));
            return {
                loading: false,
                timer: null,
                title:'Parts Location',
                tableConfig:{
                    name: 'master-table-part-location',
                    controls:{
                        create: this.$checkRole(this.$accessModule.parts_replacement, 'create'),
                        delete: this.$checkRole(this.$accessModule.parts_replacement, 'delete')
                    },
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-right',
                            tdClass: 'checkbox-column text-right no-edit',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'id',
                            label: 'ID',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: false,
                            with:150,
                            thClass: 'checkbox-column text-right',
                            tdClass: 'checkbox-column text-right',
                        },
                        {
                            key: 'finance_limit',
                            label: 'Finance Limit',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:250px",
                            sorting: true,
                            with:250,
                            thClass: 'checkbox-column text-left',
                            tdClass: 'checkbox-column text-left',
                        }
                    ],
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems:[],
                modals:{
                    create:{
                        loading:false,
                        open:false,
                        data:{
                            id:null,
                            name:null
                        }
                    },
                    update:{
                        loading:false,
                        open:false,
                        data:{
                            id:null,
                            name:null
                        }
                    }
                }
            }
        },
        created() {},
        computed: {
            ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        methods: {
            rowClick(item) {
                let objeClone = Object.assign({},item);
                this.modals.update.data.name = objeClone.name;
                this.modals.update.data.id = objeClone.id;
                this.modals.update.open = true;
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("PartReplacementController/getPartLocation", tableRequest)
                .then(response => {                        
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$alertNotification("Can not load parts location.", "danger");
                    reject();
                });
            },
            async getPartLocation(){
                let tableRequest = {
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                };
                await this.$store.dispatch("PartReplacementController/getPartLocation", tableRequest)
                .then(response => {                        
                    this.tableItems = response.items;
                     this.tableConfig.total = response.total;
                })
            },
            newItem(){
                this.modals.create.data.id   = null;
                this.modals.create.data.name = null;
                this.modals.create.open = true;
            },
            async deleteItems(callback){
                const {
                    ids,
                    filter,
                    resolve,
                    reject
                } = await callback();
                await this.$store.dispatch('PartReplacementController/deletePartLocation', ids)
                .then(response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    resolve(this.$alertNotification("Successfully deleted part location", "success"));
                })
                .catch(err => {
                    reject();
                })
            },
            savePartLocation(){
                if(!this.modals.create.data.name){
                    return this.$alertNotification("Part Location Name is required", "danger"); 
                }
                let objeClone = {
                    name: this.modals.create.data.name
                };
                this.modals.create.loading = true;
                this.$store.dispatch("PartReplacementController/createPartLocation", objeClone)
                .then(response => {
                    this.$alertNotification("Successfully added part location", "success"); 
                    this.modals.create.loading = false;
                    this.getPartLocation();
                    this.modals.create.open = false;
                })
                .catch(err => {
                    this.modals.create.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })
            },
            updatePartLocation(){
                if(!this.modals.update.data.name){
                    return this.$alertNotification("Part Location Name is required", "danger"); 
                }
                let objeClone = {
                    id: this.modals.update.data.id,
                    name: this.modals.update.data.name
                };
                this.modals.update.loading = true;
                this.$store.dispatch("PartReplacementController/updatePartLocation", objeClone)
                .then(response => {
                    this.$alertNotification("Successfully updated part location", "success"); 
                    this.modals.update.loading = false;
                    this.getPartLocation();
                    this.modals.update.open = false;
                })
                .catch(err => {
                    this.modals.update.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })
            }
        }
    }
</script>
